/**
 * Serialises a value to JSON and escapes characters that could break
 * out of an inline `<script>` tag, preventing stored-XSS attacks.
 *
 * Safe to use inside `dangerouslySetInnerHTML`.
 */
export function safeJsonStringify(value: unknown): string {
    return JSON.stringify(value)
        .replaceAll("<", String.raw`\u003c`)
        .replaceAll(">", String.raw`\u003e`);
}
